import { useQuery } from '@tanstack/react-query';

import { ITopicTests } from '../models';
import { getTopicTestById } from '../queries';
import { topicTestsConst } from '..';

export const useTopicTestById = (id?: string | string[] | undefined) =>
  useQuery<ITopicTests>({
    queryKey: [topicTestsConst.queryKeys.USE_TOPIC_TEST_BY_ID, id],
    queryFn: () => getTopicTestById(id),
    enabled: !!id
  });
